import { ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAuth } from "../hooks/useAuth";

type LockProps = {
  children?: ReactNode;
  sentence?: string;
};

export const Lock = ({ children, sentence }: LockProps) => {
  const { isLogged } = useAuth();

  if (isLogged) {
    return <>{children}</>;
  }

  return (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Tooltip id="tooltip-unlock">
          <i className="bi bi-lock-fill"></i>{" "}
          {sentence ?? "Subscribe to see the full list of stocks"}
        </Tooltip>
      }
    >
      <div className="app-lock">
        <div className="app-lock-content">{children}</div>
      </div>
    </OverlayTrigger>
  );
};
